import { StrictMode, useEffect, useState, useCallback } from "react";
import { RouterProvider } from "react-router/dom";
import { useDispatch, useSelector } from "react-redux";

import { Backdrop } from "@mui/material";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import LoadingFallback from "./modules/common/components/LoadingFallback";
import ErrorDialog from "./modules/common/components/ErrorDialog";
import router from "./router";
import { uiActions } from "./modules/common/store/uiReducer";

// MSAL configuration
const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID,
    authority: process.env.REACT_APP_MS_AUTH_URL,
    redirectUri: `${process.env.PUBLIC_URL}/public/login`,
  },
};

export default function App() {
  const loadingMessage = useSelector((state) => state.ui.loadingMessage);
  const errorMessages = useSelector((state) => state.ui.errorMessages);

  const [pcaInstance, setPcaInstance] = useState(null);

  const dispatch = useDispatch();

  const getPcaInstance = useCallback(async () => {
    if (process.env.REACT_APP_MS_CLIENT_ID && process.env.REACT_APP_MS_TENANT_ID && process.env.REACT_APP_MS_AUTH_URL) {
      const pca = new PublicClientApplication(msalConfig);

      await pca.initialize().catch((err) => {
        console.error("Error initializing MSAL:", err);

        dispatch(uiActions.setErrors(err));
      });

      setPcaInstance(pca);
    } else {
      dispatch(uiActions.setErrors("Missing MS configuration"));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!pcaInstance) {
      (async () => {
        await getPcaInstance();
      })();
    }
  }, [pcaInstance, getPcaInstance]);

  return (
    <StrictMode>
      {loadingMessage && (
        <Backdrop open={!!loadingMessage} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.tooltip + 1 })}>
          <LoadingFallback message={loadingMessage} />
        </Backdrop>
      )}

      {errorMessages && <ErrorDialog />}

      {!pcaInstance && <LoadingFallback message="Initializing..." />}

      {!!pcaInstance && (
        <MsalProvider instance={pcaInstance}>
          <RouterProvider router={router} />
        </MsalProvider>
      )}
    </StrictMode>
  );
}
